import { PricingInputType, Scheduling } from '@src/core/buyerApiClient';
import type { TariffsPerType } from '../types/tariff';
import { getSelectedTariff } from './tariffLookup';

export const serializePricingTariffSelections = (listOfTariffsPerType: TariffsPerType[]): string =>
  listOfTariffsPerType
    .map((t) => {
      const tariff = getSelectedTariff(t, null);
      return tariff ? { tariffId: tariff.id, quantity: t.selectedQuantity } : null;
    })
    .filter((s): s is { tariffId: string; quantity: number } => s !== null)
    .sort((a, b) => a.tariffId.localeCompare(b.tariffId)) // deterministic order for cache key stability
    .map((s) => `${s.tariffId}:${s.quantity}`)
    .join(',');

export const tariffsRequireQuantityPricing = (scheduling: Scheduling): boolean =>
  scheduling.tariffScheduleUnitPrices.some((tsup) =>
    tsup.tariffs.some((t) => t.requiredPricingInputs?.includes(PricingInputType.TariffQuantity)),
  );
